export enum WantedListTypeEnum {
  National = 'national',
  International = 'international',
}
